import { FC } from "react";
import { Typography } from "antd";
import {
  StyledDateWrapper,
  StyledLink,
  StyledTag,
  StyledText,
  StyledTitle,
  StyledTytleWrapper,
} from "./styled";
import { CalendatIcon } from "../icons/CalendatIcon";
import { EApproveStatus } from "../../types";

interface IProps {
  date: string;
  to: string;
  status: EApproveStatus;
  title: string;
  text: string;
}

export const SeriesCard: FC<IProps> = ({ date, to, status, title, text }) => {
  return (
    <StyledLink to={to}>
      <StyledTytleWrapper>
        <StyledTitle level={5}>{title}</StyledTitle>

        <StyledDateWrapper>
          <CalendatIcon fill="#8c8c8c" />

          <StyledText>{date}</StyledText>

          <StyledTag
            className={status === EApproveStatus.ACTUAL ? "actual" : "updated"}
          >
            {status === EApproveStatus.ACTUAL ? "Актуально" : "Обновлено"}
          </StyledTag>
        </StyledDateWrapper>
      </StyledTytleWrapper>
      <Typography.Text
        style={{ fontSize: "16px", color: "#4A5368" }}
        ellipsis={true}
      >
        {text}
      </Typography.Text>
    </StyledLink>
  );
};
